<div
  class="mx-10 flex h-full flex-col items-center justify-between gap-4 rounded-4xl border-2 border-background-white bg-background-modal p-6 shadow-modal backdrop-blur-modal"
>
  <div class="relative flex w-full justify-center">
    <span class="typo-h2 text-text-primary">{{ 'common_image_category_full_series' | translate }}</span>
    <button class="absolute right-0 top-0" (click)="onCloseClick()">
      <svg-icon class="text-text-primary" key="px-16-x" size="sm"></svg-icon>
    </button>
  </div>
  <div
    class="relative flex h-full w-full justify-center overflow-hidden rounded-4xl bg-background-white/80"
    [ngClass]="{
      'px-24 py-6': !inPreviewMode()
    }"
  >
    @if (inPreviewMode()) {
      <div class="flex h-full w-full flex-col">
        <div class="flex h-full min-h-0 flex-col bg-background-white p-8">
          <div class="flex flex-col">
            <button class="btn-text w-fit" (click)="goBack()">
              <svg-icon class="text-primary-blue" key="px-16-arrow-left"></svg-icon>
              {{ 'imaging_back_button' | translate }}
            </button>
          </div>
          <lib-image-preview-container
            class="mt-1 flex h-full min-h-0 w-full justify-center"
            [selectedImage]="selectedImage()"
            [inEditMode]="inEditMode()"
            [comparisonImage]="comparisonImage()"
            [selectedImages]="selectedImages()"
            (goToEditMode)="goToEditMode(true)"
          ></lib-image-preview-container>
        </div>
        <lib-image-tray
          [gallery]="gallery()"
          [editMode]="inEditMode()"
          [selectedImage]="selectedImage()"
          [selectedImageId]="selectedImage()?.id"
          [comparisonImageId]="comparisonImage()?.id"
          [compareMode]="inCompareMode()"
          [comparisonImages]="selectedImages()"
          [filteredGallery]="filteredImages()"
          (imageSelected)="onImageClick($event)"
          (toggleCompareMode)="toggleCompareMode()"
          (comparisonImageSelected)="setComparisonImage($event)"
          (setEditMode)="goToEditMode($event)"
        />
      </div>
    }
    <lib-full-series
      #fullSeries
      class="items-center"
      [ngClass]="{
        '!hidden': inPreviewMode()
      }"
      [fullSeries]="dialogData.fullSeries"
      [selectionMode]="inDownloadMode()"
      [selectedImageIds]="dialogData.selectedImageIds ?? []"
      (imageClick)="onImageClick($event)"
    />
  </div>
  @if (!inPreviewMode() && !inDownloadMode()) {
    <div class="relative flex w-full justify-end">
      <span class="typo-h2 text-text-primary"> &nbsp; </span>
      <button type="button" class="btn-text px-4 pt-1" (click)="onAddToSelectionClick()">
        {{ 'collab_message_select_images' | translate }}
      </button>
    </div>
  }

  @if (inDownloadMode()) {
    <div class="relative flex w-full justify-center gap-2">
      <span class="typo-h2 text-text-primary"> &nbsp; </span>
      <div class="typo-h5-light flex items-center justify-center">
        <svg-icon key="px-24-tick" class="text-secondary-green"></svg-icon>
        <span class="text-text-tertiary">
          {{
            (fullSeries.selectedImageIdsSignal().length > 1
              ? 'collab_image_selector_modal_image_selected_plural'
              : 'collab_image_selector_modal_image_selected'
            ) | translate: { input1: fullSeries.selectedImageIdsSignal().length }
          }}
        </span>
      </div>
      <div class="absolute right-0 flex gap-10 justify-self-end">
        <button type="button" class="btn-text" (click)="onCloseClick()">
          {{ 'collab_message_select_images_cancel_selection' | translate }}
        </button>
        <button type="button" class="btn-primary" (click)="onAddToSelectionClick()">
          {{ 'collab_message_select_images_save_selection' | translate }}
        </button>
      </div>
    </div>
  }
</div>
